export const EVENTS = {
    REPORTS_UPDATED: 'reports-updated',
};
export const CONSTANTS = {
    MIN_RANGE: 93,
    MIN_RANGE_EXTENDED: 185,
    DEFAULT_DATE_FORMAT: 'DD/MM/YYYY',
    GET_CATEGORIES_TAKE_SIZE: 1000,
    GET_CHARTS_TAKE_SIZE: 1000,
};
